import React from 'react';

const FIELDS = [
  ['customer_name', 'Zákazník'], ['model', 'Model', 'model'], ['serial_number', 'Sériové číslo'],
  ['contract_date', 'Smlouva ze dne', 'date'], ['install_address', 'Adresa instalace'], ['planned_date', 'Termín odvozu', 'date'],
  ['contact_name', 'Kontaktní osoba na místě'], ['contact', 'Telefon / e-mail'], ['technician_name', 'Technik BASICGAME'],
];

// "Údaje o zakázce" – prefilled from the ERP (machine, customer, site, contact person), editable
const OrderStep = ({ header, onChange, disabled }) => (
  <section className="dlv-card" aria-labelledby="dlv-order">
    <div className="dlv-section-head">
      <span className="dlv-section-head__num">00</span>
      <h2 id="dlv-order" className="dlv-section-head__title">Údaje o zakázce</h2>
    </div>
    <p className="dlv-hint">Předvyplněno z ERP podle trenažéru, zákazníka a jeho provozovny. Úpravy se projeví jen v tomto protokolu.</p>
    <div className="dlv-grid">
      {FIELDS.map(([key, label, type]) => (
        <label key={key}>
          <span className="dlv-label">{label}</span>
          {type === 'model' ? (
            <select className="dlv-input" value={header.model || 'TR3'} disabled={disabled} onChange={(e) => onChange({ model: e.target.value })}>
              <option value="TR3">TR3</option>
              <option value="TR4">TR4</option>
            </select>
          ) : (
            <input className="dlv-input" type={type || 'text'} value={header[key] || ''} disabled={disabled}
              onChange={(e) => onChange({ [key]: e.target.value })} />
          )}
        </label>
      ))}
    </div>
    <p className="dlv-hint" style={{ marginTop: 14 }}>Body označené <span className="dlv-tag">TR4</span> se u modelu TR3 přeskakují.</p>
  </section>
);

export default OrderStep;
